import React from 'react'
import Link from '@mui/material/Link'
import { MyMLabel } from '../ui-elements/MyMLabel'

export const MyMLink = (props) => {
  const {
    fontSize,
    // 2024.5.8 MyMine Version1.5対応 Add Start
    notUseLabel,
    // 2024.5.8 MyMine Version1.5対応 Add End
    ...other } = props;
  return (
    <Link {...other} component={props.component ?? "button"}>
      {
        // 2024.5.8 MyMine Version1.5対応 Add Start
        notUseLabel
          ? <>{props.children}</>
        // 2024.5.8 MyMine Version1.5対応 Add End
        :<MyMLabel component='span' fontSize={fontSize ?? '1rem'}>{props.children}</MyMLabel>
      }
    </Link>
  )
}

export const MyMBlackLink = (props) => {
  const { sx, ...other } = props;

  return (
    <MyMLink sx={{
      color: 'black',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
      ...sx
    }} {...other}>
      {props.children}
    </MyMLink>
  )
}
